module.exports = __webpack_public_path__ + "static/media/mic-icon.2f53ffc6.png";